<template>
    <section class="categoryBlock manufacturer" v-if="visible">
        <div class="contentBox">
            <h2 v-html="name"></h2>
            <div v-html="manufacturer.comment"></div>
            <!--
            <a class="btn btn-nw btn-sm" :href="'/brands/?brand=' + manufacturer.id">Sortiment von {{ manufacturer.externalName }}</a>
            -->
        </div>
        <div class="imageBox">
            <lazy-img :image-url="imageUrl" />
        </div>
    </section>
</template>

<script>
export default {

    name: "manufacturer",

    props: {
        paddingClasses:
        {
            type: String,
            default: null
        }
    },

    inject: {
        itemId: {
            default: null
        }
    },

    computed:
    {
        currentVariation() {
            return this.$store.getters[`${this.itemId}/currentItemVariation`]
        },
        
        visible()
        {
            return this.currentVariation 
                && this.currentVariation.variation.id 
                && this.currentVariation.item.manufacturer 
                && this.currentVariation.item.manufacturer.id !== null;
        },

        manufacturer()
        {
            if(this.visible)
            {
                return this.currentVariation.item.manufacturer;
            }
            return null;
        },

        imageUrl()
        {
            if(this.manufacturer == null)
            {
                return "";
            }

            return this.manufacturer.logo;
        },

        name()
        {
            if(this.manufacturer == null)
            {
                return "";
            }

            let name  = '<span class="label r">Gefertigt von</span>';
                name += '<span class="name">' + this.manufacturer.externalName + '</span>';

            return name;
        }
    }
}
</script>
